import { Typography } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../../../../Components/Button"
import Modal from "../../../../../../Components/Modal"
import Icon from "../../../../../../Icon"

import styles from "./finishSuccessModal.module.less"

const { Title, Text } = Typography

// Success pop-up shown after finishing a processor in Configure. Two modes:
//  - 'processor': one of several connected processors is done. The merchant chooses:
//    set up the next processor now, OR continue to Preferences and activate Recover
//    with just this one (the remaining processor can be configured later).
//  - 'all': every connected processor is set up (or there was only one).
// mode === null keeps it closed.
const FinishSuccessModal = ({
  mode,
  name,
  next,
  onContinue,
  onGoToPreferences,
  onGoToDisputes
}) => {
  const { t } = useTranslation()
  const isProcessor = mode === "processor"
  return (
    <Modal
      visible={!!mode}
      handleClose={onGoToDisputes}
      footer={null}
      width={442}
      closeIcon={<Icon type="cross_small" />}
      classNames={{ content: "clear-bg full-width-header" }}
    >
      <div className={styles.finishModal}>
        <div className={styles.finishModalIcon}>
          <Icon type="circle_check_green" style={{ fontSize: 48 }} />
        </div>
        <Title level={4} className={styles.finishModalTitle}>
          {isProcessor ? t("_name_ is set up", { name }) : t("Recover is set up")}
        </Title>
        <Text type="secondary" className="rcv-finish-modal_body">
          {isProcessor
            ? t(
                "_name_ is ready. Set up _next_ too so its disputes are covered, or continue to Preferences and activate Recover with _name_ only. You can add _next_ later.",
                { name, next }
              )
            : t(
                "We're now fighting your disputes automatically. New chargebacks from your connected processors are synced and answered for you."
              )}
        </Text>
        <div className={styles.finishModalActions}>
          {isProcessor ? (
            <>
              <Button
                type="primary"
                size="large"
                block
                onClick={onContinue}
                text={t("Set up _next_", { next })}
              />
              <Button
                type="default"
                size="large"
                block
                onClick={onGoToPreferences}
                text={t("Continue to Preferences")}
              />
            </>
          ) : (
            <Button
              type="primary"
              size="large"
              block
              onClick={onGoToDisputes}
              text={t("Go to disputes")}
            />
          )}
        </div>
      </div>
    </Modal>
  )
}

export default FinishSuccessModal
